import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface ColumnsProps {
  columns: string[];
}

export const Columns = (props: ColumnsProps) => {
  return props.columns && props.columns.length > 0 ? (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{Messages.column_table_columns()}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>
        { props.columns.join(', ') }
      </span>
    </div>
  ) : null;
};